<template>
    <div class="requirements-list-area bg-gray" id="requirement">
        <div class="row align-items-center">
            <div class="col-lg-6 order-2 order-xl-1">
                <div class="requirements-list">
                    <!-- <h2 class="requirements-list__title mb-15 wow move-up">マーケットデータ</h2>
                    <p class="requirements-list__text heading mb-30 wow move-up"> オフィス、インダストリアルおよびリテールにおけるマーケットデータ</p>
                    <ul class="check-list green-check-list section-space--mb_50 wow move-up">
                        <li class="list-item">過去・最新の情報を閲覧</li>
                        <li class="list-item">データ ビジュアライゼーション</li>
                        <li class="list-item">オフィス、インダストリアルに関しては予測</li>
                    </ul> -->
                    <h6 class="margin-bottom-10">{{lan.key20[cur_lan]}}</h6>
                    <hr>
                    <p class="margin-bottom-0">{{lan.key21[cur_lan]}}</p>
                    <ul class="ul-style margin-bottom-20">
                        <li>{{lan.key22[cur_lan]}}</li>
                        <li>{{lan.key23[cur_lan]}}</li>
                    </ul>
                    <p class="margin-bottom-0">{{lan.key24[cur_lan]}}</p>
                    <ul class="ul-style margin-bottom-20">
                        <li>{{lan.key25[cur_lan]}}</li>
                        <li>{{lan.key26[cur_lan]}}</li>
                    </ul>
                    <p class="margin-bottom-0">{{lan.key27[cur_lan]}}</p>
                    <ul class="ul-style margin-bottom-20">
                        <li>{{lan.key28[cur_lan]}}</li>
                        <li>{{lan.key29[cur_lan]}}</li>
                    </ul>
                    <hr>
                    <div class="tab-button wow move-up">
                        <a :href="'https://cbre.creis.jp/#cur_lan='+cur_lan" class="ht-btn ht-btn-md">{{lan.key30[cur_lan]}}</a>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 order-1 order-xl-2">
                <div class="requirements-list-image wow move-up">
                    <img src="../assets/img_design/img/pc/japan_map.png" class="img-fluid" alt="">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'requireList',
         data (){
            return {
               
                cur_lan:localStorage.getItem('cur_lan') || 'jp',
                lan:JSON.parse(localStorage.getItem('creis_web_language_data')).data,
            }
        },
    }
</script>